
import { RevIllustration } from '@ds/components/Illustration'
import { IconLeaf } from '@ds/icons/IconLeaf'
import { mapGetters } from 'vuex'

import { PAGE_TYPE_BY_ROUTE_NAME } from '@tracking/constants'
import { trackClick } from '@tracking/events'

import translations from './EcoBlockAnchor.translations'

export default {
  components: {
    RevIllustration,
    IconLeaf,
  },

  props: {
    shouldDisplayEcoBlock: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      experiments: 'flags/getExperiments',
    }),

    translations: () => translations,

    pageType() {
      const routeName = this.$route.name

      return PAGE_TYPE_BY_ROUTE_NAME[routeName]
    },

    shouldDisplayVersionA() {
      return !this.shouldDisplayVersionB && !this.shouldDisplayVersionC
    },

    shouldDisplayVersionB() {
      return (
        this.experiments.ppReassuranceNewDesign === 'newDesign' ||
        this.experiments.ppReassuranceNewDesign === 'newDesignMergedInfo'
      )
    },

    // Postponed
    shouldDisplayVersionC() {
      return false
    },
  },

  methods: {
    handleClick(e) {
      // Let's prevent the default anchor behavior (keeping the anchor it for a11y)
      e.preventDefault()

      trackClick({
        name: 'go_to_ecoBlock',
        pageType: this.pageType,
        zone: 'detail',
      })

      // Using getElementById instead of ref as the target is in another component
      document.getElementById('ecoBlocks').scrollIntoView({
        behavior: 'smooth',
        // Centering the block in the page to avoid sticky elements hidden the first lines.
        block: 'center',
      })
    },
  },
}
